import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Checkbox,
  FormControlLabel,
  Grid,
  makeStyles,
} from "@material-ui/core";
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import Button from "../../components/CustomButtons/Button";
import CustomTextField from "components/UpdateUi/CustomeTextField";
import CustomDateField from "components/UpdateUi/CustomDateField";
import CustomSelect from "components/UpdateUi/CustomeSelect";
import { parseDate } from "utils/Utils";
import { saveUserLeadId } from "store/reducers/login/LoginSlice";
import ToastModal from "views/components/ToastModal";
import { incomeDetailsValidations } from "assets/properties/properties";
import BottomButton from "components/UpdateUi/BottomButton/BottomButton";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
  },
  content: {
    flexGrow: 1,
    overflowY: "auto",
    paddingBottom: theme.spacing(2),
  },
  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
  },
  inputFieldContainer: {
    margin: "0 auto",
    maxWidth: "1100px",
  },
  fieldContaienr: {
    margin: "2% 2% 0px 0px",
    maxWidth: "31.3%",
    "@media (max-width: 768px)": {
      maxWidth: "46%",
      margin: "5% 2% 0px 2%",
    },
    "@media (max-width: 600px)": {
      maxWidth: "100%",
    },
    "@media (max-width: 450px)": {
      margin: "10% 2% 0px 2%",
    },
  },
}));

const IncomeDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [dob, setDob] = useState("");
  const [monthlySalary, setMonthlySalary] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyDetails, setCompanyDetails] = useState({});
  const [dateOfJoining,setDateOfJoining]= useState("");
  const [dateOfExit,setDateOfExit]= useState("");
  const [pfUan,setpfUan]= useState("");
  const [companyNameDisabled, setCompanyNameDisabled] = useState(false);
  const [employmentType, setEmploymentType] = useState("SALARIED");
  const [callInProgress, setCallInProgress] = useState(false);
  const [panData, setPanData] = useState({});
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [incomeDetailsAvailable, setIncomeDetailsAvailable] = useState(false);
  const { authToken } = useSelector((state) => state.login.authData);
  const { leadId } = useSelector((state) => state.login.userCurrentLead);
  const { mobileNumber } = useSelector((state) => state.login.userData);
  const [disaledFields, setDisabledFields] = useState(false);
  const [consentCheck, setConsentCheck] = useState(true);

  // Branch related state
  const [branchDetails, setBranchDetails] = useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = useState("");

  // Location state
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [locationLoading, setLocationLoading] = useState(false);
  const minSalary = incomeDetailsValidations?.minSalary;
  const minAge = incomeDetailsValidations?.minAge;
  const maxAge = incomeDetailsValidations?.maxAge;
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  // Fetch loan summary on mount
  useEffect(() => {
    fetchLoanSummary();
    getUserLocationAndBranches();
    // eslint-disable-next-line
  }, []);

  // Get user location and fetch branches around location
  const getUserLocationAndBranches = () => {
    console.log("Geolocation is not supported by this browser1111");
    if (!navigator.geolocation) {
      console.log("Geolocation is not supported by this browser222222222222");
      return;
    }
    console.log("Geolocation is not supported by this browser333333333");
    setLocationLoading(true);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setLatitude(latitude);
        setLongitude(longitude);
        console.log(latitude,longitude,"Geolocation is not supported by this browser333333333");
        await fetchBranchDetailsByLocation(latitude, longitude);
        setLocationLoading(false);
      },
      (error) => {
        setLocationLoading(false);
        console.error("Error getting location:", error.message);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 }
    );
  };

  // Fetch branches based on latitude and longitude
const fetchBranchDetailsByLocation = async (lat, lng) => {
  setCallInProgress(true);
  try {
    const res = await apiHandler({
      url: `${endpoint.GET_BRANCHES_BY_LOCATION_API}?lat=${lat}&lng=${lng}&radius=1000`,
      method: "GET",
      authToken: authToken,
    });

    console.log(res?.data, "fskdjjfsjkdb");

    if (res?.data?.features?.length > 0) {
      const pincodesArray = res.data.features
        .map(item => item?.properties?.postcode)
        .filter(Boolean);
      
      const formattedPincodes = pincodesArray
        .map(pincode => `"${pincode}"`)
        .join(",");
      console.log(formattedPincodes,"fdkhfsdh")
      await checkForBlackListPincode(formattedPincodes)
    }else{
      fetchBranchDetails();
    }
  } catch (error) {
    console.error("Error fetching branches by location:", error);
  } finally {
    setCallInProgress(false);
  }
};
  const checkForBlackListPincode = async (formattedPincodes) => {
    setCallInProgress(true);
    try {
      const res = await apiHandler({
        url: endpoint.MASTER_BLACK_LIST_PINCODE_FIND_BY_PINCODE + formattedPincodes,
        method: "GET",
        authToken: authToken,
      });
      if (res?.data?.error_code) {
        toastUpdate("Error",res?.data?.user_description,true)
      } else {
        if(!res?.data?.blacklisted){
          await fetchBranchDetails(formattedPincodes)
        }else{
          toastUpdate(
            "Error",
            "Delivery is currently unavailable for this pincode. Please enter a different pincode or contact support.",
            true
          );
        }
      }
    } catch (error) {
      console.error("Error fetching branch details:", error);
    } finally {
      setCallInProgress(false);
    }
  }
 const fetchBranchDetails = async (formattedPincodes) => {
  setCallInProgress(true);
  try {
    const res = await apiHandler({
      url: endpoint.GET_BRANCHES_LIST_API + formattedPincodes,
      method: "GET",
      authToken: authToken,
    });
    if (res?.data?.length) {
      const branchDetailsFormatted = res.data.map(branch => ({
        value: branch.code,
        label: branch.name,
      }));
      setSelectedBranchCode(branchDetailsFormatted?.[0]?.value)
    } else {
      setBranchDetails([]);
    }
  } catch (error) {
    console.error("Error fetching branch details:", error);
    setBranchDetails([]);
  } finally {
    setCallInProgress(false);
  }
};

  const fetchLoanSummary = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.GET_LEAD_INCOME_DETAILS_API + leadId,
      method: "GET",
      authToken: authToken,
    });
    if (result?.data?.employmentType) {
      setIncomeDetailsAvailable(true);
      setDisabledFields(true);
      setDob(result?.data?.dob);
      setMonthlySalary(result?.data?.monthlyIncome);
      setCompanyName(result?.data?.companyName);
      setEmploymentType(result?.data?.employmentType);
      if (result?.data?.branchCode) {
        setSelectedBranchCode(result?.data?.branchCode);
      }
      const res = await apiHandler({
        url: endpoint.GET_USER_PAN_DETAILS_API + mobileNumber,
        authToken: authToken,
      });
      if (res?.data?.dob) {
        setDob(res?.data?.dob);
        setPanData(res?.data);
      }
      setCallInProgress(false);
    } else {
      setDisabledFields(false);
      const res = await apiHandler({
        url: endpoint.GET_USER_PAN_DETAILS_API + mobileNumber,
        authToken: authToken,
      });
      if (res?.data?.dob) {
        setDob(res?.data?.dob);
        setPanData(res?.data);
      }
      setCallInProgress(false);
      // const result = await apiHandler({
      //   url: endpoint.GET_USER_PPF_DETAILS_API + mobileNumber,
      //   authToken: authToken,
      // });
      // console.log(result,"akdfjshdfj")
      // if(result?.data?.error_code){
        setDateOfJoining(new Date());
        setDateOfExit("");
        setpfUan("");
      // }else {
      //   setCompanyDetails(result?.data);
      //   setDateOfJoining(result?.data?.dateOfJoining);
      //   setDateOfExit(result?.data?.dateOfExit);
      //   setpfUan(result?.data?.pfUan);
      //   setCompanyName(result?.data?.companyName);
      //   setCompanyNameDisabled(true);
      // }
      // const result2 = {
      //   companyName: "ADOBE SYSTEM INDIA PVT LTD.",
      //   dateOfExit: "2022-08-09",
      //   dateOfJoining: "2021-08-09",
      //   pfUan: "101120955923",
      // };
      // if (result2?.companyName) 
       
    }
  };

  const sumitLoanDetails = async () => {
    if(incomeDetailsAvailable){
      navigate("/journey/AadharDetails");
      return;
    }
    setCallInProgress(true);
    let res = {};
    if(!leadId){
       res = await apiHandler({
        url: endpoint.NEW_LEAD_CREATE_API,
        method: "POST",
        authToken: authToken,
        data: {
          productType: "PERSONAL_LOAN",
          dob: parseDate(dob),
          employmentType: employmentType,
          dateOfJoining: parseDate(dateOfJoining) || "",
          dateOfExit: parseDate(dateOfExit) || "",
          salary: monthlySalary,
          monthlyIncome: monthlySalary,
          companyName: companyName,
          panNumber: panData?.panNumber,
          pfUan: pfUan,
          branchCode: selectedBranchCode,
        },
      });
    }else{
      res = await apiHandler({
        url: endpoint.ALREADY_LEAD_PRESENT_API,
        method: "POST",
        authToken: authToken,
        data: {
          productType: "PERSONAL_LOAN",
          dob: parseDate(dob),
          employmentType: employmentType,
          dateOfJoining: parseDate(dateOfJoining) || "",
          dateOfExit: parseDate(dateOfExit) || "",
          monthlyIncome: monthlySalary,
          companyName: companyName,
          panNumber: panData?.panNumber,
          pfUan: pfUan,
          leadApplicationId:leadId,
          salary: monthlySalary,
          branchCode: selectedBranchCode,
        },
      });
    }
    if (res?.data?.error_code) {
      toastUpdate("Error", res.data.user_description, true);
      setCallInProgress(false);
    } else {
      dispatch(
        saveUserLeadId({
          leadId: !leadId ? res?.data?.id : res?.data?.loanApplicationId,
          leadStatus: "INPROCESS",
        })
      );
      navigate("/journey/AadharDetails");
    }
  };

  const isFormValid = () => {
    if (disaledFields) return true;
    const isSalaryValid = parseInt(monthlySalary) >= minSalary;
    return (
      dob &&
      monthlySalary &&
      companyName &&
      employmentType &&
      isSalaryValid &&
      consentCheck &&
      selectedBranchCode
    );
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        <SubHeader
          label="Income Details"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        {locationLoading && <p>Loading location and branches...</p>}
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomDateField
              label="Date of Birth / Incorporation Date"
              value={dob}
              onChange={setDob}
              className={classes.inputField}
              disabled={disaledFields}
              minYears={minAge}
              maxYears={maxAge}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Monthly Salary"
              placeholder="Monthly Salary"
              value={monthlySalary}
              onChange={(e) => setMonthlySalary(e.target.value)}
              style={classes.inputField}
              type="number"
              disabled={disaledFields}
              helperText={
                !disaledFields &&
                monthlySalary &&
                parseInt(monthlySalary) < minSalary
                  ? "Salary must be at least ₹15,000"
                  : "Minimum salary required is ₹15,000"
              }
              error={
                !disaledFields &&
                monthlySalary &&
                parseInt(monthlySalary) < minSalary
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="Company Name"
              placeholder="Company Name"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              style={classes.inputField}
              disabled={disaledFields}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelect
              label="Employment type"
              value={employmentType}
              onChange={(e) => setEmploymentType(e.target.value)}
              options={[
                { value: "SALARIED", label: "Salaried" },
              ]}
              style={classes.documentSelectBox}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomTextField
              label="PanCard Number"
              placeholder="PanCard Number"
              value={panData?.panNumber}
              style={classes.inputField}
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} className={classes.fieldContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={consentCheck}
                  onChange={(e) => setConsentCheck(e.target.checked)}
                  color="primary"
                  disabled={disaledFields}
                />
              }
              label={`I declare that my monthly salary income is greater than ₹ ${minSalary.toLocaleString()}.`}
            />
          </Grid>
        </Grid>
      </Grid>
       <Grid item xs={12}>
        <BottomButton
          button1={incomeDetailsAvailable ? "Next" : "Submit"}
          button1click={sumitLoanDetails}
          disabled1={!isFormValid()}
        />
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

export default IncomeDetails;
